// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"39e9c5a8","455":"ff1d3ac8","977":"0a179943"}[chunkId] + ".chunk.js";
};